function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if(document.querySelector('.product-addcart')){
  document.querySelector('.product-addcart').addEventListener('click',function(evt){
    evt.preventDefault();
    let variant_id = evt.target.closest('form').querySelector('input[name="id"]').getAttribute('value');
    let qty = evt.target.closest('form').querySelector('.quantity__input').value;
    let formData = {
      'items': [{
        'id': variant_id,
        'quantity': qty
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((response) => {      
      if (response.status) {
        document.querySelector('.product-form-error').innerHTML = response.description;
        setTimeout(function(e){
          document.querySelector('.product-form-error').innerHTML  = '';
        },2000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          if(window.outerWidth > 991){
            setTimeout(function(e){
              document.querySelector('body').classList.remove('stickybar');
              document.querySelector('body').classList.add('open-drawer');
            },500);
          }else{
            cartNotification(response.items[0].id);
          }
        }else{
          window.location.href = "/cart";
        }
      }
      evt.target.closest('form').querySelector('.added-cart').style.display = 'flex';
      evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'none';
      setTimeout(function(e){
        evt.target.closest('form').querySelector('.added-cart').style.display = 'none';
        evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'flex';
      },2000);
      gtag("event", "add_to_cart", {
        currency: Shopify.currency.active,
        value: response.items[0].price,
        items: [
          {
            item_id: response.items[0].product_id,
            item_name: response.items[0].product_title,
            affiliation: "Google Merchandise Store",
            discount: response.items[0].price - (response.items[0].price * 0.10),
            index: 0,
            item_brand: response.items[0].product_type,
            item_list_id: "related_products",
            item_list_name: "Related Products",
            item_variant: response.items[0].variant_title,
            price: response.items[0].price,
            quantity: response.items[0].quantity
          }
        ]
      });
    })
    .catch((e) => {console.error(e);})
    .finally(() => {});
  });
}
if(document.querySelector('.sticky-add')){
  document.querySelector('.sticky-add').addEventListener('click',function(evt){
    evt.preventDefault();
    let variant_id = evt.target.closest('form').querySelector('input[name="id"]').getAttribute('value');
    let qty;
    if(window.outerWidth > 991){
      qty = evt.target.closest('form').querySelector('.quantity__input').value;
    }else{
      qty = document.querySelector('.sticky-info .quantity .quantity__input').value;
    }
    let formData = {
      'items': [{
        'id': variant_id,
        'quantity': qty
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((response) => {      
      if (response.status) {
        document.querySelector('.product-form-error').innerHTML = response.description;
        setTimeout(function(e){
          document.querySelector('.product-form-error').innerHTML  = '';
        },2000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          if(window.outerWidth > 991){
            setTimeout(function(e){
              document.querySelector('body').classList.remove('stickybar');
              document.querySelector('body').classList.add('open-drawer');
            },500);
          }else{
            cartNotification(response.items[0].id);
          }
        }else{
          window.location.href = "/cart";
        }
      }
      evt.target.closest('form').querySelector('.added-cart').style.display = 'flex';
      evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'none';
      setTimeout(function(e){
        evt.target.closest('form').querySelector('.added-cart').style.display = 'none';
        evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'flex';
      },2000);
      gtag("event", "add_to_cart", {
        currency: Shopify.currency.active,
        value: response.items[0].price,
        items: [
          {
            item_id: response.items[0].product_id,
            item_name: response.items[0].product_title,
            affiliation: "Google Merchandise Store",
            discount: response.items[0].price - (response.items[0].price * 0.10),
            index: 0,
            item_brand: response.items[0].product_type,
            item_list_id: "related_products",
            item_list_name: "Related Products",
            item_variant: response.items[0].variant_title,
            price: response.items[0].price,
            quantity: response.items[0].quantity
          }
        ]
      });
    })
    .catch((e) => {console.error(e);})
    .finally(() => {});
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      slidesPerView: "auto",
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    let zoomSwiper = new Swiper(".zoom-main",{
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 0,
      centeredSlides: true,
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    function initMedia(){
      document.querySelectorAll('.media-thumb').forEach((allThumb) => {
        allThumb.querySelectorAll('.init-media').forEach((thumb) => {
          thumb.addEventListener('click',function(e){
            e.preventDefault();
            document.querySelectorAll('.media-thumb .media-grid-column').forEach((img) => {
              img.classList.remove('active');
            });
            thumb.classList.add('active');
            swiper.slideTo(thumb.getAttribute('data-index'));
            zoomSwiper.slideTo(thumb.getAttribute('data-index'));
          })
        })
      })
    }
    initMedia();
    if(document.querySelectorAll('.more-media')){
      document.querySelectorAll('.more-media').forEach((moreMeida) => {
        moreMeida.addEventListener('click',function(e){
          e.preventDefault();
          moreMeida.closest('.media-thumb').classList.add('active-media');
          moreMeida.closest('.media-grid-column').classList.add('init-media');
          moreMeida.closest('.media-thumb').querySelectorAll('.media-grid-column.hide-media').forEach((hideMedia) => {
            hideMedia.classList.add('init-media');
            hideMedia.style.display = 'block';
          })
          setTimeout(() => {initMedia();}, 100);
        })
      })
    }
    if(document.querySelector('.product-media-zoom')){
      document.querySelector('.product-media-zoom').addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.add('open-zoom');
        zoomSwiper.update();
      })
    }
  }
  if(document.querySelector('.zoom-close')){
    document.querySelector('.zoom-close').addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-zoom');
    })
  }
  if(document.querySelector('.product-size-chart a')){
    document.querySelector('.product-size-chart a').addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.add('open-size-chart');
    })
  }
  if(document.querySelector('.size-popup-close')){
    document.querySelector('.size-popup-close').addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-size-chart');
    })
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}
document.addEventListener("DOMContentLoaded", (e) => {
  let swiperImages = new Swiper('.prod-img-wrap',{
    loop: false,
    slidesPerView: "auto",
    navigation: {
      nextEl: '.snippet-product-images .swiper-button-next',
      prevEl: '.snippet-product-images .swiper-button-prev',
    },
    a11y: false,
    pagination: {
      el: ".snippet-product-images .swiper-pagination",
      type: "progressbar"
    },
    spaceBetween: 8,
    breakpoints:{
      992:{
        spaceBetween: 10
      }
    }
  })
});
document.addEventListener("DOMContentLoaded", () => {
  // let totalheight;
  // if(document.querySelector('.snippet-addto-cart')){
  //   if(window.outerWidth > 991){
  //     totalheight = document.querySelector('.snippet-addto-cart').offsetTop;
  //   }else{
  //     totalheight = document.querySelector('.snippet-addto-cart').offsetTop + document.querySelector('.product-info').offsetTop + document.querySelector('.sticky-info').offsetTop - document.querySelector('header').clientHeight;
  //   }
  // }
  // let widnowheight = window.outerHeight
  // let otherTop = document.getElementById('shopify-section-footer').offsetTop
  // window.addEventListener('scroll', (e)=>{
  //   let cartheight = totalheight - widnowheight;    
  //   let scroll = window.pageYOffset;
  //   if(scroll >= (totalheight + 150)){
  //     document.querySelector('body').classList.add('stickybar');
  //   }else{
  //     document.querySelector('body').classList.remove('stickybar');
  //   }
  //   if((scroll >= (otherTop + cartheight))){
  //     document.querySelector('body').classList.remove('stickybar');
  //   }
  // });
  // let totalheight;
  // if(document.querySelector('.snippet-addto-cart')){
  //   if(window.outerWidth > 991){
  //     totalheight = document.querySelector('.snippet-addto-cart').offsetTop;
  //   }else{
  //     totalheight = (document.querySelector('.snippet-addto-cart').offsetTop + document.querySelector('.product-info').offsetTop + document.querySelector('.sticky-info').offsetTop) - document.querySelector('header').clientHeight;
  //   }
  // }
  // let widnowheight = window.outerHeight
  // let otherTop = document.getElementById('shopify-section-footer').offsetTop
  // window.addEventListener('scroll', (e)=>{
  //   let cartheight = totalheight - widnowheight;
    
  //   let scroll = window.pageYOffset;
  //   console.log(scroll,'----',otherTop,cartheight,'totalheight',totalheight);
  //   if(scroll >= (totalheight + 150)){
  //     document.querySelector('body').classList.add('stickybar');
  //   }else{
  //     document.querySelector('body').classList.remove('stickybar');
  //   }
  //   if(scroll >= (otherTop + cartheight)){
  //     document.querySelector('body').classList.remove('stickybar');
  //   }
  // });
  if(document.querySelector('.sticky-product-cart .choose-selector a')) document.querySelector('.sticky-product-cart .choose-selector a').addEventListener('click',function(e){
    e.preventDefault();
    if(window.outerWidth > 991){
      // window.scrollTo(0, document.getElementById('product-form-installment').offsetTop + document.querySelector('header').clientHeight);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 400);
    }else{
      window.scrollTo(0, document.getElementById('product-form-installment').offsetTop + document.querySelector('.product-info').offsetTop + document.querySelector('.sticky-info').offsetTop - document.querySelector('header').clientHeight);
    }
  })
  var prodAccoClose = document.querySelectorAll('.prod-acco-close, .product-overly');
  if(prodAccoClose) prodAccoClose.forEach(function(accoClose) {
    accoClose.addEventListener('click', function(e){
      e.preventDefault();
      document.querySelectorAll('.accordian-wrap.active').forEach((openAcco) => {
        openAcco.classList.remove('active');
      })
    });
  });
  document.body.addEventListener('click',function(e){
    if(event.target.closest('.accordian-wrap')) if(!event.target.classList.contains('accordian-title') && !event.target.classList.contains('prod-acco-mb-head') && !event.target.classList.contains('rte') && !event.target.classList.contains('acco-cont-wrap') && event.target.closest('.accordian-wrap').classList.contains('active')) {
      event.target.closest('.accordian-wrap').classList.remove('active');
      if(event.target.closest('.accordian-content')) event.target.closest('.accordian-content').style.maxHeight = '';
    }
  })
  if(document.querySelectorAll('.combine-variant')){
    document.querySelectorAll('.combine-variant').forEach((combineVariant) => {
      combineVariant.addEventListener('click',function(e){
        e.preventDefault();
        let combinesOpen = combineVariant.closest('.combine-drodown').querySelectorAll("ul li.active");
        combinesOpen.forEach((combineOpen) => {
          combineOpen.classList.remove("active");
        });
        combineVariant.closest('li').classList.add('active');
        combineVariant.closest('.combine-btm').querySelector('.combine-cart-button').setAttribute('data-id',combineVariant.getAttribute('data-id'));
        combineVariant.closest('.combine-btm').querySelector('.combine-select-size').style.display = 'none';
        combineVariant.closest('.combine-btm').querySelector('.combine-cart-button').style.display = 'block';
        if(window.outerWidth < 992){
          let data = {
            'items': [{
              'id': combineVariant.getAttribute('data-id'),
              'quantity': 1
            }]
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then((response) => response.json())
          .then((response) => {
            if(typeof load_cart == 'function'){
              load_cart();
              if(window.outerWidth > 991){
                setTimeout(function(e){
                  document.querySelector('body').classList.remove('stickybar');
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                cartNotification(response.items[0].id);
              }
            }else{
              window.location.href = "/cart";
            }
            gtag("event", "add_to_cart", {
              currency: Shopify.currency.active,
              value: response.items[0].price,
              items: [
                {
                  item_id: response.items[0].product_id,
                  item_name: response.items[0].product_title,
                  affiliation: "Google Merchandise Store",
                  discount: response.items[0].price - (response.items[0].price * 0.10),
                  index: 0,
                  item_brand: response.items[0].product_type,
                  item_list_id: "related_products",
                  item_list_name: "Related Products",
                  item_variant: response.items[0].variant_title,
                  price: response.items[0].price,
                  quantity: response.items[0].quantity
                }
              ]
            });
          })
          .catch((e) => {console.error(e);})
        }
      })
    })
  }
  if(document.querySelectorAll('.combine-cart-button')){
    document.querySelectorAll('.combine-cart-button').forEach((combine) => {
      combine.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = combine.getAttribute('data-id');
        let added = combine.querySelector('.combine-added-text');
        let add = combine.querySelector('.combine-add-text');
        let data = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
        .then((response) => response.json())
        .then((response) => {
          if(typeof load_cart == 'function'){
            load_cart();
            added.style.display = 'flex';
            add.style.display = 'none';
            setTimeout(() => {
              added.style.display = 'none';
              add.style.display = 'flex';
            }, 5000);
            setTimeout(() => {
              document.querySelector('body').classList.remove('stickybar');
              document.querySelector('body').classList.add('open-drawer');
            }, 500);
          }else{
            window.location.href = "/cart";
          }
          gtag("event", "add_to_cart", {
            currency: Shopify.currency.active,
            value: response.items[0].price,
            items: [
              {
                item_id: response.items[0].product_id,
                item_name: response.items[0].product_title,
                affiliation: "Google Merchandise Store",
                discount: response.items[0].price - (response.items[0].price * 0.10),
                index: 0,
                item_brand: response.items[0].product_type,
                item_list_id: "related_products",
                item_list_name: "Related Products",
                item_variant: response.items[0].variant_title,
                price: response.items[0].price,
                quantity: response.items[0].quantity
              }
            ]
          });
        })
        .catch((e) => {console.error(e);})
      })
    })
  }
});

// window.addEventListener('scroll', function() {
//     var div = document.querySelector('.snippet-addto-cart.prod-meta-5-col');
//     var body = document.body;
//     var rect = div.getBoundingClientRect();
//     var topOffset = rect.top;
//     if (topOffset <= 0) {
//       document.querySelector('body').classList.add('stickybar');
//       var sectionFooter = document.querySelector('.section-footer');
//       var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//       var section = sectionFooter.offsetTop - scrollTop - window.innerHeight;
//       var Buttons = document.querySelectorAll('.snippet-sticky-product-cart');
//       Buttons.forEach(function(button) {
//         if(section < 0){
//           button.style.display = 'none';
//         } else {
//           button.style.display = 'block';
//         }
//       });
//     } else {
//       document.querySelector('body').classList.remove('stickybar');
//     }
// });